// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   Button,
//   IconButton,
//   Menu,
//   MenuItem,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import MoreVertIcon from "@mui/icons-material/MoreVert";

// const EmployeeSelector = ({
//   selectedEmployees,
//   isEdit,
//   onOpenLookup,
//   onAddEmployees,
//   handleUploadExcel,
//   handleDownloadTemplate,
//   searchTerm,
//   setSearchTerm,
// }) => {
//   const [searchMode, setSearchMode] = useState(false);
//   const [menuAnchorEl, setMenuAnchorEl] = useState(null);
//   const [selectedPreviewEmployee, setSelectedPreviewEmployee] = useState(null);
//   const fileInputRef = useRef(null);

//   const employeeOptions = useMemo(
//     () => selectedEmployees || [],
//     [selectedEmployees]
//   );

//   useEffect(() => {
//     if (!employeeOptions.length) {
//       setSelectedPreviewEmployee(null);
//       return;
//     }

//     setSelectedPreviewEmployee((current) => {
//       if (current && employeeOptions.some((emp) => emp.id === current.id)) {
//         return current;
//       }
//       return employeeOptions[0];
//     });
//   }, [employeeOptions]);

//   const handleMenuOpen = (event) => {
//     setMenuAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setMenuAnchorEl(null);
//   };

//   const handleBulkUploadClick = () => {
//     handleMenuClose();
//     fileInputRef.current?.click();
//   };

//   return (
//     <Box
//       className="employee-selector-shell"
//       sx={{
//         mb: 2,
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 1.25,
//         flexWrap: "wrap",
//       }}
//     >
//       <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "320px" } }}>
//         {isEdit ? (
//           <TextField
//             value={selectedEmployees.map((e) => e.employeeName).join(", ")}
//             disabled
//             label="Assigned Employees"
//             fullWidth
//           />
//         ) : searchMode ? (
//           <TextField
//             className="employee-selector-field"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             label="Search Employees"
//             placeholder="Search employees in the table"
//             fullWidth
//             autoFocus
//             InputProps={{
//               startAdornment: <SearchIcon sx={{ mr: 1, color: "#6B7280" }} />,
//             }}
//             sx={{
//               backgroundColor: "#fff",
//               "& .MuiInputBase-root": {
//                 minHeight: 56,
//                 borderRadius: 2,
//               },
//             }}
//           />
//         ) : (
//           <Autocomplete
//             options={employeeOptions}
//             value={selectedPreviewEmployee}
//             onChange={(event, newValue) => setSelectedPreviewEmployee(newValue)}
//             getOptionLabel={(option) => option?.employeeName || ""}
//             isOptionEqualToValue={(option, value) => option?.id === value?.id}
//             disabled={employeeOptions.length === 0}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 className="employee-selector-field"
//                 label="Selected Employees"
//                 placeholder={employeeOptions.length ? "Select employee" : "No employees selected"}
//                 fullWidth
//                 sx={{
//                   backgroundColor: "#fff",
//                   "& .MuiInputBase-root": {
//                     minHeight: 56,
//                     borderRadius: 2,
//                   },
//                   "& .MuiInputBase-input.Mui-disabled": {
//                     WebkitTextFillColor: "#111827",
//                     opacity: 1,
//                   },
//                 }}
//                 InputProps={{
//                   ...params.InputProps,
//                   style: { paddingRight: 14 },
//                 }}
//               />
//             )}
//           />
//         )}
//       </Box>

//       {!isEdit && (
//         <Tooltip title="Search employees in table">
//           <IconButton
//             className="employee-search-toggle-btn"
//             onClick={() => setSearchMode((prev) => !prev)}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//               "&:hover": { backgroundColor: "#f9fafb" },
//             }}
//           >
//             <SearchIcon sx={{ color: searchMode ? "#0191c8" : "#4b5563" }} />
//           </IconButton>
//         </Tooltip>
//       )}

//       {!isEdit && (
//         <Button
//           className="btn BlueBtn employee-add-btn"
//           onClick={() => onAddEmployees?.(selectedEmployees)}
//           disabled={!selectedEmployees?.length}
//           sx={{
//             minHeight: 55,
//             whiteSpace: "nowrap",
//             flexShrink: 0,
//           }}
//         >
//           Add Employee
//         </Button>
//       )}

//       {!isEdit && (
//         <Tooltip title="Lookup employees">
//           <IconButton
//             className="employee-lookup-btn"
//             onClick={onOpenLookup}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//               "&:hover": { backgroundColor: "#f9fafb" },
//             }}
//           >
//             <img
//               className="employee-lookup-icon"
//               src="/images/lookupIcon.png"
//               alt="Lookup employees"
//               style={{ width: 45, height: 55, objectFit: "contain" }}
//             />
//           </IconButton>
//         </Tooltip>
//       )}

//       {!isEdit && (
//         <Tooltip title="Bulk actions">
//           <IconButton
//             className="employee-menu-btn"
//             onClick={handleMenuOpen}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//               "&:hover": { backgroundColor: "#f9fafb" },
//             }}
//           >
//             <MoreVertIcon sx={{ color: "#4b5563" }} />
//           </IconButton>
//         </Tooltip>
//       )}

//       <Menu
//         anchorEl={menuAnchorEl}
//         open={Boolean(menuAnchorEl)}
//         onClose={handleMenuClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <MenuItem onClick={handleDownloadTemplate}>Template Download</MenuItem>
//         <MenuItem onClick={handleBulkUploadClick}>Bulk Upload</MenuItem>
//       </Menu>

//       <input
//         ref={fileInputRef}
//         type="file"
//         accept=".xlsx,.xls"
//         multiple
//         onChange={(event) => {
//           handleUploadExcel?.(event);
//           handleMenuClose();
//         }}
//         style={{ display: "none" }}
//       />
//     </Box>
//   );
// };

// export default EmployeeSelector;


// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   Button,
//   IconButton,
//   Menu,
//   MenuItem,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import MoreVertIcon from "@mui/icons-material/MoreVert";

// const EmployeeSelector = ({
//   selectedEmployees,
//   isEdit,
//   onOpenLookup,
//   onAddEmployees,
//   handleUploadExcel,
//   handleDownloadTemplate,
//   searchTerm,
//   setSearchTerm,
//   employees, // ✅ NEW
// }) => {
//   const [searchMode, setSearchMode] = useState(false);
//   const [menuAnchorEl, setMenuAnchorEl] = useState(null);
//   const [selectedPreviewEmployee, setSelectedPreviewEmployee] = useState(null);
//   const fileInputRef = useRef(null);

// const employeeOptions = useMemo(
//   () => employees || [],
//   [employees]
// );
//   useEffect(() => {
//     if (!employeeOptions.length) {
//       setSelectedPreviewEmployee(null);
//       return;
//     }

//     setSelectedPreviewEmployee((current) => {
//       if (current && employeeOptions.some((emp) => emp.id === current.id)) {
//         return current;
//       }
//       return employeeOptions[0];
//     });
//   }, [employeeOptions]);

//   const handleMenuOpen = (event) => {
//     setMenuAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setMenuAnchorEl(null);
//   };

//   const handleBulkUploadClick = () => {
//     handleMenuClose();
//     fileInputRef.current?.click();
//   };

//   const toggleSearchMode = () => {
//     setSearchMode((prev) => !prev);
//     if (searchMode) {
//       setSearchTerm(""); // reset when going back
//     }
//   };

//   return (
//     <Box
//       className="employee-selector-shell"
//       sx={{
//         mb: 2,
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 1.25,
//         flexWrap: "wrap",
//       }}
//     >
//       {/* INPUT FIELD */}
//       <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "320px" } }}>
//         {searchMode ? (
//           <TextField
//             className="employee-selector-field"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             label="Search Employees"
//             placeholder="Search employees in the table"
//             fullWidth
//             autoFocus
//             InputProps={{
//               startAdornment: (
//                 <SearchIcon sx={{ mr: 1, color: "#6B7280" }} />
//               ),
//             }}
//             sx={{
//               backgroundColor: "#fff",
//               "& .MuiInputBase-root": {
//                 minHeight: 56,
//                 borderRadius: 2,
//               },
//             }}
//           />
//         ) : (
//           <Autocomplete
//             options={employeeOptions}
//             value={selectedPreviewEmployee}
//             onChange={(event, newValue) =>
//               setSelectedPreviewEmployee(newValue)
//             }
//             getOptionLabel={(option) => option?.employeeName || ""}
//             isOptionEqualToValue={(option, value) =>
//               option?.id === value?.id
//             }
//             disabled={employeeOptions.length === 0}
//             openOnFocus
//             selectOnFocus
//             clearOnEscape
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 className="employee-selector-field"
//                 label="Selected Employees"
//                 placeholder={
//                   employeeOptions.length
//                     ? "Select employee"
//                     : "No employees selected"
//                 }
//                 fullWidth
//                 sx={{
//                   backgroundColor: "#fff",
//                   "& .MuiInputBase-root": {
//                     minHeight: 56,
//                     borderRadius: 2,
//                   },
//                 }}
//               />
//             )}
//           />
//         )}
//       </Box>

//       {/* TOGGLE BUTTON */}
//       {!isEdit && (
//         <Tooltip
//           title={searchMode ? "Back to selection" : "Search employees"}
//         >
//           <IconButton
//             onClick={toggleSearchMode}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//               "&:hover": { backgroundColor: "#f9fafb" },
//             }}
//           >
//             {searchMode ? (
//               <img
//                 src="/images/lookupIcon.png"
//                 alt="Back"
//                 style={{ width: 28, height: 28 }}
//               />
//             ) : (
//               <SearchIcon sx={{ color: "#4b5563" }} />
//             )}
//           </IconButton>
//         </Tooltip>
//       )}

//       {/* ADD BUTTON */}
//       {!isEdit && !searchMode && (
//         <Button
//           className="btn BlueBtn employee-add-btn"
//           onClick={() => onAddEmployees?.(selectedEmployees)}
//           disabled={!selectedEmployees?.length}
//           sx={{
//             minHeight: 55,
//             whiteSpace: "nowrap",
//             flexShrink: 0,
//           }}
//         >
//           Add Employee
//         </Button>
//       )}

//       {/* LOOKUP BUTTON */}
//       {!isEdit && (
//         <Tooltip title="Lookup employees">
//           <IconButton
//             onClick={onOpenLookup}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//             }}
//           >
//             <img
//               src="/images/lookupIcon.png"
//               alt="Lookup"
//               style={{ width: 28, height: 28 }}
//             />
//           </IconButton>
//         </Tooltip>
//       )}

//       {/* MENU */}
//       {!isEdit && (
//         <>
//           <Tooltip title="Bulk actions">
//             <IconButton
//               onClick={handleMenuOpen}
//               sx={{
//                 width: 45,
//                 height: 55,
//                 borderRadius: 1.5,
//                 border: "1px solid #d1d5db",
//                 backgroundColor: "#fff",
//               }}
//             >
//               <MoreVertIcon sx={{ color: "#4b5563" }} />
//             </IconButton>
//           </Tooltip>

//           <Menu
//             anchorEl={menuAnchorEl}
//             open={Boolean(menuAnchorEl)}
//             onClose={handleMenuClose}
//           >
//             <MenuItem onClick={handleDownloadTemplate}>
//               Template Download
//             </MenuItem>
//             <MenuItem onClick={handleBulkUploadClick}>
//               Bulk Upload
//             </MenuItem>
//           </Menu>

//           <input
//             ref={fileInputRef}
//             type="file"
//             accept=".xlsx,.xls"
//             multiple
//             onChange={(event) => {
//               handleUploadExcel?.(event);
//               handleMenuClose();
//             }}
//             style={{ display: "none" }}
//           />
//         </>
//       )}
//     </Box>
//   );
// };

// export default EmployeeSelector;



// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Autocomplete,
//   Box,
//   Button,
//   IconButton,
//   Menu,
//   MenuItem,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import MoreVertIcon from "@mui/icons-material/MoreVert";

// const EmployeeSelector = ({
//   selectedEmployees,
//   isEdit,
//   onOpenLookup,
//   onAddEmployees,
//   handleUploadExcel,
//   handleDownloadTemplate,
//   searchTerm,
//   setSearchTerm,
//   employees,
//   setSelectedEmployees, \
//   fetchEmployees, 
// }) => {
//   const [searchMode, setSearchMode] = useState(false);
//   const [menuAnchorEl, setMenuAnchorEl] = useState(null);

//   const fileInputRef = useRef(null);

// const employeeOptions = useMemo(() => {
//   if (!employees) return [];

//   if (!searchTerm?.trim()) return employees;

//   const term = searchTerm.toLowerCase();

//   return employees.filter(
//     (emp) =>
//       emp.employeeName?.toLowerCase().includes(term) ||
//       emp.employeeId?.toLowerCase().includes(term)
//   );
// }, [employees, searchTerm]);

//   const handleMenuOpen = (event) => {
//     setMenuAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => {
//     setMenuAnchorEl(null);
//   };

//   const handleBulkUploadClick = () => {
//     handleMenuClose();
//     fileInputRef.current?.click();
//   };

//   const toggleSearchMode = () => {
//     setSearchMode((prev) => !prev);
//     if (searchMode) {
//       setSearchTerm(""); // reset when going back
//     }
//   };

// useEffect(() => {
//   const delay = setTimeout(() => {
//     if (searchMode) {
//       fetchEmployees?.([], searchTerm); // ✅ backend call
//     }
//   }, 400); // debounce

//   return () => clearTimeout(delay);
// }, [searchTerm, searchMode, fetchEmployees]);


//   return (
//     <Box
//       className="employee-selector-shell"
//       sx={{
//         mb: 2,
//         display: "flex",
//         flexDirection: "row",
//         alignItems: "center",
//         gap: 1.25,
//         flexWrap: "wrap",
//       }}
//     >
//       {/* INPUT FIELD */}
//       <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "320px" } }}>
//         {searchMode ? (
//           <TextField
//             className="employee-selector-field"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             label="Search Employees"
//             placeholder="Search employees in the table"
//             fullWidth
//             autoFocus
//             InputProps={{
//               startAdornment: (
//                 <SearchIcon sx={{ mr: 1, color: "#6B7280" }} />
//               ),
//             }}
//             sx={{
//               backgroundColor: "#fff",
//               "& .MuiInputBase-root": {
//                 minHeight: 56,
//                 borderRadius: 2,
//               },
//             }}
//           />
//         ) : (
//           <Autocomplete
//   multiple
//   options={employeeOptions}
//   value={selectedEmployees}
//   onChange={(event, newValue) => {
//     setSelectedEmployees(newValue);
//   }}
//   getOptionLabel={(option) => option?.employeeName || ""}
//   isOptionEqualToValue={(option, value) => option?.id === value?.id}
//   filterSelectedOptions
//   renderInput={(params) => (
//     <TextField
//       {...params}
//       label="Select Employees"
//       placeholder="Select employees"
//       fullWidth
//       sx={{
//         backgroundColor: "#fff",
//         "& .MuiInputBase-root": {
//           minHeight: 56,
//           borderRadius: 2,
//         },
//       }}
//     />
//   )}
// />
//         )}
//       </Box>
//       {/* TOGGLE BUTTON */}
     
//       {/* ADD BUTTON */}
//       {!isEdit && !searchMode && (
//         <Button
//           className="btn BlueBtn employee-add-btn"
//           onClick={() => onAddEmployees?.(selectedEmployees)}
//           disabled={!selectedEmployees?.length}
//           sx={{
//             minHeight: 55,
//             whiteSpace: "nowrap",
//             flexShrink: 0,
//           }}
//         >
//           Add Employee
//         </Button>
//       )}

//        {!isEdit && (
//         <Tooltip
//           title={searchMode ? "Back to selection" : "Search employees"}
//         >
//           <IconButton
//             onClick={toggleSearchMode}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//               "&:hover": { backgroundColor: "#f9fafb" },
//             }}
//           >
//             {searchMode ? (
//               <img
//                 src="/images/emp.png"
//                 alt="Back"
//                 style={{ width: 32, height: 28 }}
//               />
//             ) : (
//               <SearchIcon sx={{ color: "#4b5563" }} />
//             )}
//           </IconButton>
//         </Tooltip>
//       )}
//       {/* LOOKUP BUTTON */}
//       {!isEdit && (
//         <Tooltip title="Lookup employees">
//           <IconButton
//             onClick={onOpenLookup}
//             sx={{
//               width: 45,
//               height: 55,
//               borderRadius: 1.5,
//               border: "1px solid #d1d5db",
//               backgroundColor: "#fff",
//               flexShrink: 0,
//             }}
//           >
//             <img
//               src="/images/lookupIcon.png"
//               alt="Lookup"
//               style={{ width: 28, height: 28 }}
//             />
//           </IconButton>
//         </Tooltip>
//       )}
//       {/* MENU */}
//       {!isEdit && (
//         <>
//           <Tooltip title="Bulk actions">
//             <IconButton
//               onClick={handleMenuOpen}
//               sx={{
//                 width: 45,
//                 height: 55,
//                 borderRadius: 1.5,
//                 border: "1px solid #d1d5db",
//                 backgroundColor: "#fff",
//               }}
//             >
//               <MoreVertIcon sx={{ color: "#4b5563" }} />
//             </IconButton>
//           </Tooltip>
//           <Menu
//             anchorEl={menuAnchorEl}
//             open={Boolean(menuAnchorEl)}
//             onClose={handleMenuClose}
//           >
//             <MenuItem onClick={handleDownloadTemplate}>
//               Template Download
//             </MenuItem>
//             <MenuItem onClick={handleBulkUploadClick}>
//               Bulk Upload
//             </MenuItem>
//           </Menu>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept=".xlsx,.xls"
//             multiple
//             onChange={(event) => {
//               handleUploadExcel?.(event);
//               handleMenuClose();
//             }}
//             style={{ display: "none" }}
//           />
//         </>
//       )}
//     </Box>
//   );
// };

// export default EmployeeSelector;


import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const EmployeeSelector = ({
  selectedEmployees,
  isEdit,
  onOpenLookup,
  onAddEmployees,
  handleUploadExcel,
  handleDownloadTemplate,
  searchTerm,
  setSearchTerm,
  employees,
  setSelectedEmployees,
  fetchEmployees,
}) => {
  const [searchMode, setSearchMode] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const fileInputRef = useRef(null);

  // ✅ No frontend filtering — backend handles it
  const employeeOptions = useMemo(() => {
    return employees || [];
  }, [employees]);

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleBulkUploadClick = () => {
    handleMenuClose();
    fileInputRef.current?.click();
  };

  const toggleSearchMode = () => {
    setSearchMode((prev) => !prev);
    if (searchMode) {
      setSearchTerm(""); // reset when going back
    }
  };

  // ✅ Backend search trigger (debounced)
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchEmployees?.([], searchTerm);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchTerm, fetchEmployees]);

  return (
    <Box
      className="employee-selector-shell"
      sx={{
        mb: 2,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1.25,
        flexWrap: "wrap",
      }}
    >
      {/* INPUT FIELD */}
      <Box sx={{ flex: 1, minWidth: { xs: "100%", sm: "320px" } }}>
        {searchMode ? (
          <TextField
            className="employee-selector-field"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            label="Search Employees"
            placeholder="Search employees in the table"
            fullWidth
            autoFocus
            InputProps={{
              startAdornment: (
                <SearchIcon sx={{ mr: 1, color: "#6B7280" }} />
              ),
            }}
            sx={{
              backgroundColor: "#fff",
              "& .MuiInputBase-root": {
                minHeight: 56,
                borderRadius: 2,
              },
            }}
          />
        ) : (
          <Autocomplete
            multiple
            options={employeeOptions}
            value={selectedEmployees}
            onChange={(event, newValue) => {
              setSelectedEmployees(newValue);
            }}
            onInputChange={(event, value) => {
              setSearchTerm(value); // ✅ triggers backend
            }}
            getOptionLabel={(option) => option?.employeeName || ""}
            isOptionEqualToValue={(option, value) =>
              option?.id === value?.id
            }
            filterSelectedOptions
            filterOptions={(options) => options} // ✅ disable local filtering
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Employees"
                placeholder="Select employees"
                fullWidth
                sx={{
                  backgroundColor: "#fff",
                  "& .MuiInputBase-root": {
                    minHeight: 56,
                    borderRadius: 2,
                  },
                }}
              />
            )}
          />
        )}
      </Box>

      {/* ADD BUTTON */}
      {!isEdit && !searchMode && (
        <Button
          className="btn BlueBtn employee-add-btn"
          onClick={() => onAddEmployees?.(selectedEmployees)}
          disabled={!selectedEmployees?.length}
          sx={{
            minHeight: 55,
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          Add Employee
        </Button>
      )}

      {/* TOGGLE SEARCH */}
      {!isEdit && (
        <Tooltip
          title={searchMode ? "Back to selection" : "Search employees"}
        >
          <IconButton
            onClick={toggleSearchMode}
            sx={{
              width: 45,
              height: 55,
              borderRadius: 1.5,
              border: "1px solid #d1d5db",
              backgroundColor: "#fff",
              flexShrink: 0,
              "&:hover": { backgroundColor: "#f9fafb" },
            }}
          >
            {searchMode ? (
              <img
                src="/images/emp.png"
                alt="Back"
                style={{ width: 32, height: 28 }}
              />
            ) : (
              <SearchIcon sx={{ color: "#4b5563" }} />
            )}
          </IconButton>
        </Tooltip>
      )}

      {/* LOOKUP BUTTON */}
      {!isEdit && (
        <Tooltip title="Lookup employees">
          <IconButton
            onClick={onOpenLookup}
            sx={{
              width: 45,
              height: 55,
              borderRadius: 1.5,
              border: "1px solid #d1d5db",
              backgroundColor: "#fff",
              flexShrink: 0,
            }}
          >
            <img
              src="/images/lookupIcon.png"
              alt="Lookup"
              style={{ width: 28, height: 28 }}
            />
          </IconButton>
        </Tooltip>
      )}

      {/* MENU */}
      {!isEdit && (
        <>
          <Tooltip title="Bulk actions">
            <IconButton
              onClick={handleMenuOpen}
              sx={{
                width: 45,
                height: 55,
                borderRadius: 1.5,
                border: "1px solid #d1d5db",
                backgroundColor: "#fff",
              }}
            >
              <MoreVertIcon sx={{ color: "#4b5563" }} />
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleDownloadTemplate}>
              Template Download
            </MenuItem>
            <MenuItem onClick={handleBulkUploadClick}>
              Bulk Upload
            </MenuItem>
          </Menu>

          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls"
            multiple
            onChange={(event) => {
              handleUploadExcel?.(event);
              handleMenuClose();
            }}
            style={{ display: "none" }}
          />
        </>
      )}
    </Box>
  );
};

export default EmployeeSelector;